import { isAxiosError } from 'axios';

// 5xx bodies are generic server text, so only trust 4xx messages for display
export function getApiErrorMessage(error: unknown, fallback: string) {
  if (!isAxiosError(error) || !error.response) return fallback;
  if (error.response.status >= 500) return fallback;
  const message: unknown = error.response.data?.message;
  if (typeof message === 'string' && message) return message;
  if (Array.isArray(message) && message.length) return message.join(', ');
  return fallback;
}
